import React, { useState } from "react";
import { Box } from '@mui/material';
import Appliedlists from "./appliedJobsList";
import Projects from "./appliedProjectslist";

const AppliedList = () => {
  const [activeTab, setActiveTab] = useState("Appliedlists");

  return (
    <Box p={3} width="100%">
      <div style={{ display: "flex", gap: "16px", marginBottom : "20px" }}>
        <button
          onClick={() => setActiveTab("Appliedlists")}
          style={{
            padding: "10px 20px",
            background: activeTab === "Appliedlists" ? "#1976d2" : "#f0f0f0",
            color: activeTab === "Appliedlists" ? "#fff" : "#333",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Internships & Jobs
        </button>
        <button
          onClick={() => setActiveTab("projects")}
          style={{
            padding: "10px 20px",
            background: activeTab === "projects" ? "#1976d2" : "#f0f0f0",
            color: activeTab === "projects" ? "#fff" : "#333",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Projects
        </button>
      </div>

      <div>
        {activeTab === "Appliedlists" && <Appliedlists />}
        {activeTab === "projects" && <Projects />}
      </div>
    </Box>
  );
};

export default AppliedList;
